import React, { useContext, useEffect, useState } from 'react';
import {
  AAMBeaconControl,
  AAMBeaconError,
} from 'components/shared/Beacon';
import Store from 'state/Store';
import { startCase, toLower, cloneDeep } from 'lodash';
import '../BeneficiaryDataCardBody.scss';
import {
  updateBeneficiary
} from 'state/beneficiaries/BeneficiaryActions';
import {
  distributeEvenly,
  findBeneficiaryById,
  renderAllocationDesignation,
  getDisplayName,
  validateTotalDistribution,
  validateTotalDistributionFormatted
} from 'services/BeneficiaryV2';
import BeneficiaryContext from '../BeneficiaryContext';

const renderBeneficiaryDetails = ({ beneficiaries, type, handleInputChange, handleToggleChange, toggleState, isEsa }) => {
  return (
    <>
      <div className="b-grid-item--12-col b-typography-sans-serif--headline--100 b-font-weight-bold">
        {`${renderAllocationDesignation(type, isEsa)} beneficiaries`}
      </div>
      {beneficiaries.length > 0 &&
        <>
          <div
            className="b-grid-item--9-col b-typography-sans-serif--body--100 b-font-weight-bold">
            Divide allocation automatically
          </div>
          <div className="beacon-on-light b-grid-item--3-col">
            <AAMBeaconControl inline toggle-switch>
              <label htmlFor={'toggleState' + type} slot="label">
                <span className="toggle-text" aria-hidden="true">
                  On
                </span>
              </label>
              <input
                type="checkbox"
                aria-label={'toggleState' + `${type}`}
                name="options"
                id={'toggleState' + type}
                checked={toggleState}
                onChange={() => handleToggleChange(type)}
              />
            </AAMBeaconControl>
          </div>
          {Array.isArray(beneficiaries) && beneficiaries.map((beneficiary) => {
            const {
              _id,
              name,
              nameSuffix,
              relationshipName,
              distributionAmountFormated,
              firstName,
              lastName,
              middleName,
            } = beneficiary || {};

            const displayName = getDisplayName({ name, firstName, middleName, lastName, nameSuffix });

            return (
              <React.Fragment key={_id}>
                <div className="b-grid-item--9-col b-padding-block-start--micro--normal">
                  <div className="b-typography-sans-serif--body--100 b-font-weight-light blocked_data">
                    {displayName}
                  </div>
                  <div className="b-typography-sans-serif--caption--300 blocked_data">
                    {startCase(toLower(relationshipName))}
                  </div>
                </div>
                <div className="b-grid-item--3-col">
                  <AAMBeaconControl>
                    <label htmlFor={`${type}-allocation-${_id}`} slot="label">
                      Allocation
                    </label>
                    <input
                      type="text"
                      name="Allocation"
                      id={`${type}-allocation-${_id}`}
                      value={`${distributionAmountFormated}%`}
                      required={true}
                      onKeyDown={(e) => {
                        const value = e.target.value;
                        if (e.key === 'Backspace' && value.endsWith('%')) {
                          e.target.value = value.slice(0, -1);
                        }
                        if (!/[0-9.]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== 'Tab' && e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') {
                          e.preventDefault();
                        }
                      }}
                      onBlur={(e) => {
                        const value = e.target.value;
                        if (!value.endsWith('%')) {
                          e.target.value = value + '%';
                        }
                      }}
                      onChange={(e) => handleInputChange(e, _id)}
                      disabled={toggleState}
                    />
                  </AAMBeaconControl>
                </div>
              </React.Fragment>
            );
          })}
        </>
      }
    </>
  )
};

const BeneficiaryAllocation = () => {
  const {
    beneficiaries,
    includeDistributionValidation,
    isPrimaryDistributionError,
    isSecondaryDistributionError,
    primaryTotalAllocationFormatted,
    secondaryTotalAllocationFormatted,
    setIncludeDistributionValidation,
    isEsa
  } = useContext(BeneficiaryContext);
  const { primary, secondary, primaryTotalAllocation, secondaryTotalAllocation } = beneficiaries || {};
  const [toggleStatePrimary, setToggleStatePrimary] = useState(true);
  const [toggleStateSecondary, setToggleStateSecondary] = useState(true);
  useEffect(() => {
    const updateBeneficiaries = (toggleState, beneficiariesArr) => {
      if (toggleState) {
        const distribution = distributeEvenly(beneficiariesArr.length);
        beneficiariesArr.forEach((beneficiary, index) => {
          const beneToUpdate = cloneDeep(beneficiary);
          beneToUpdate.distributionAmountFormated = distribution[index].toFixed(2);
          beneToUpdate.distributionAmount = Number(parseFloat(distribution[index] / 100).toPrecision(4));
          Store.dispatch(updateBeneficiary(beneToUpdate._id, beneToUpdate));
        });
      }
    };
    updateBeneficiaries(toggleStatePrimary, primary);
    updateBeneficiaries(toggleStateSecondary, secondary);
  }, [toggleStatePrimary, primary.length, toggleStateSecondary, secondary.length]);

  const handleInputChange = (e, beneficiaryId) => {
    const beneToUpdate = findBeneficiaryById(beneficiaryId, beneficiaries);
    beneToUpdate.distributionAmountFormated = e.target.value.replace('%', '');
    beneToUpdate.distributionAmount = parseFloat(e.target.value.replace('%', '') / 100);
    Store.dispatch(updateBeneficiary(beneficiaryId, beneToUpdate));
    setIncludeDistributionValidation(false);
  };

  const handleToggleChange = (type) => {
    if (type === 'Primary') {
      setToggleStatePrimary(!toggleStatePrimary);
    } else {
      setToggleStateSecondary(!toggleStateSecondary);
    }
  };
  return (
    <>
      {renderBeneficiaryDetails({ beneficiaries: primary, type: 'Primary', handleInputChange, handleToggleChange, toggleState: toggleStatePrimary, isEsa: isEsa })}
      <div className="b-grid-item--9-col b-typography-sans-serif--body--100 b-font-weight-light">
        Total allocation
      </div>
      <div className='b-grid-item--3-col b-typography-sans-serif--body--100 b-font-weight-bold beneficiary-allocation-total-allocation-percent'>
        {primary.length > 0 && validateTotalDistribution(primaryTotalAllocation) && includeDistributionValidation &&
          <AAMBeaconError id="beacon-error">
            Primary beneficiaries should total 100%
          </AAMBeaconError>
        }
        {!isPrimaryDistributionError && !includeDistributionValidation &&
          (validateTotalDistributionFormatted(primaryTotalAllocationFormatted) ?
             <>{primaryTotalAllocationFormatted}%</>
            :
            <AAMBeaconError id="beacon-error">
              {!isNaN(primaryTotalAllocationFormatted) ? `${primaryTotalAllocationFormatted}%` : 'Invalid Allocations'}
            </AAMBeaconError>
          )
        }
      </div>
      {!isEsa && (
        <>
          {renderBeneficiaryDetails({ beneficiaries: secondary, type: 'Secondary', handleInputChange, handleToggleChange, toggleState: toggleStateSecondary })}
          {secondary.length === 0 &&
            <div className="b-grid-item--12-col b-font-weight-light b-typography-sans-serif--body--100">
              No secondary beneficiaries
            </div>
          }
          {secondary.length > 0 &&
            <>
              <div className="b-grid-item--9-col b-typography-sans-serif--body--100 b-font-weight-light">
                Total allocation
              </div>
              <div className='b-grid-item--3-col b-typography-sans-serif--body--100 b-font-weight-bold beneficiary-allocation-total-allocation-percent'>
                {secondary.length > 0 && validateTotalDistribution(secondaryTotalAllocation) && includeDistributionValidation &&
                  <AAMBeaconError id="beacon-error">
                    Secondary beneficiaries should total 100%
                  </AAMBeaconError>
                }
                {!isSecondaryDistributionError && !includeDistributionValidation &&
                  (validateTotalDistributionFormatted(secondaryTotalAllocationFormatted) ?
                    <>{secondaryTotalAllocationFormatted}%</>
                    :
                    <AAMBeaconError id="beacon-error">
                      {!isNaN(secondaryTotalAllocationFormatted) ? `${secondaryTotalAllocationFormatted}%` : 'Invalid Allocations'}
                    </AAMBeaconError>
                  )
                }
              </div>
            </>
          }
        </>
      )}
    </>
  );
};

export default BeneficiaryAllocation;